import api from './interceptor';

export async function getSubscriptionData(date) {
    try {
        const response = await api.get("/user/subscription", { params: { date } });

        return response.data;
    } catch (e) {
        console.log(e.message);
    }
}
